/**
 * Club Farmex — huincha en ficha + overlay propio (sin Bootstrap .modal).
 * El CSS del theme fuerza .modal-dialog a ~800px y rompe el layout;
 * por eso usamos #cffFichaOverlay / #cffFichaPanel.
 *
 * Pruebas: USAR_API_LOCAL = true, o window.FARMEX_API_BASE_URL = 'https://xxxx.ngrok-free.app'
 */
(function () {
  if (window.__clubFarmexFichaInit) return;
  window.__clubFarmexFichaInit = true;

  const USAR_API_LOCAL = false;
  const FARMEX_API_BASE = 'https://services.farmex.cl';
  const NGROK_API_BASE = 'https://cab6-190-215-90-239.ngrok-free.app';

  let campaniasCache = [];

  function getApiBase() {
    if (typeof window.FARMEX_API_BASE_URL === 'string' && window.FARMEX_API_BASE_URL.trim()) {
      return window.FARMEX_API_BASE_URL.trim().replace(/\/$/, '');
    }
    return (USAR_API_LOCAL ? NGROK_API_BASE : FARMEX_API_BASE).replace(/\/$/, '');
  }

  function getApiHeaders() {
    const headers = { Accept: 'application/json' };
    if (/ngrok-free\.app|ngrok\.io|ngrok\.dev/i.test(getApiBase())) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }
    return headers;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getOverlay() {
    return document.getElementById('cffFichaOverlay');
  }

  function showOverlay() {
    const el = getOverlay();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hideOverlay() {
    const el = getOverlay();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCampanias(campanias) {
    if (!Array.isArray(campanias) || campanias.length === 0) {
      return '<p style="margin:0;color:#6b7280;font-size:18px;">No hay información de campaña disponible.</p>';
    }

    return campanias
      .map(function (campania) {
        const tramos = Array.isArray(campania.tramos) ? campania.tramos : [];
        const cols = Math.max(tramos.length, 1);

        const infoHtml =
          '<div class="cff-info">' +
          '<div class="cff-info__cell">' +
          '<div class="cff-info__label">Cómo avanza</div>' +
          '<div class="cff-info__value">' +
          escapeHtml(campania.modo_progreso_texto || 'Según las reglas de la campaña') +
          '</div></div>' +
          '<div class="cff-info__cell">' +
          '<div class="cff-info__label">Ciclicidad</div>' +
          '<div class="cff-info__value">' +
          escapeHtml(campania.ciclicidad_texto || '—') +
          '</div></div>' +
          '</div>';

        let tramosHtml = '';
        if (tramos.length === 0) {
          tramosHtml =
            '<p style="margin:0;color:#6b7280;font-size:18px;">Esta campaña aún no tiene tramos configurados.</p>';
        } else {
          tramosHtml =
            '<div class="cff-tramos" style="--cff-cols:' +
            cols +
            ';">' +
            tramos
              .map(function (tramo) {
                return (
                  '<div class="cff-tramo">' +
                  '<span class="cff-tramo__n">' +
                  escapeHtml(tramo.orden) +
                  '</span>' +
                  '<span class="cff-tramo__t"><strong>' +
                  escapeHtml(tramo.etiqueta || ('Compra ' + tramo.orden)) +
                  ':</strong> ' +
                  escapeHtml(tramo.beneficio) +
                  '</span></div>'
                );
              })
              .join('') +
            '</div>';
        }

        return (
          '<div>' +
          infoHtml +
          '<div class="cff-tramos-title">Tramos del beneficio</div>' +
          tramosHtml +
          '</div>'
        );
      })
      .join('<div style="height:1px;background:#d1d5db;margin:22px 0;"></div>');
  }

  function ordinalHuincha(orden) {
    const map = { 1: '1era', 2: '2da', 3: '3era', 4: '4ta', 5: '5ta', 6: '6ta', 7: '7ma', 8: '8va', 9: '9na' };
    return map[orden] || orden + 'ª';
  }

  function ordinalPalabra(orden) {
    const map = {
      1: 'Primera',
      2: 'Segunda',
      3: 'Tercera',
      4: 'Cuarta',
      5: 'Quinta',
      6: 'Sexta',
      7: 'Séptima',
      8: 'Octava',
      9: 'Novena',
    };
    return map[orden] || orden + 'ª';
  }

  function formatClp(valor) {
    const n = Math.round(Number(valor) || 0);
    return '$' + n.toLocaleString('es-CL');
  }

  function getPrecioClp(huinchaEl) {
    const fromData = Number(huinchaEl && huinchaEl.getAttribute('data-precio-clp'));
    if (fromData > 0) return fromData;
    const convenio = huinchaEl && huinchaEl.previousElementSibling;
    if (convenio && convenio.getAttribute) {
      const lista = Number(convenio.getAttribute('data-precio-lista'));
      if (lista > 0) return lista;
    }
    return 0;
  }

  function parseDescuento(tramo) {
    if (!tramo || tramo.tiene_descuento !== true) {
      return { tipo: 'ninguno' };
    }
    const texto = String(tramo.beneficio || '').toLowerCase();
    if (texto.indexOf('gratis') !== -1 && texto.indexOf('despacho') !== -1) {
      return { tipo: 'despacho_gratis' };
    }
    const pct = texto.match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (pct) {
      const valor = parseFloat(pct[1].replace(',', '.'));
      return { tipo: valor >= 100 ? 'gratis' : 'porcentaje', valor: valor };
    }
    if (texto.indexOf('gratis') !== -1) {
      return { tipo: 'gratis', valor: 100 };
    }
    const monto = texto.match(/\$\s*([\d.]+)/);
    if (monto) {
      return { tipo: 'monto', valor: parseInt(monto[1].replace(/\./g, ''), 10) || 0 };
    }
    return { tipo: 'otro', texto: String(tramo.beneficio || '') };
  }

  function precioFinal(precioClp, dcto) {
    if (!dcto) return precioClp;
    if (dcto.tipo === 'gratis') return 0;
    if (dcto.tipo === 'porcentaje') {
      return Math.max(0, Math.round(precioClp * (1 - Number(dcto.valor) / 100)));
    }
    if (dcto.tipo === 'monto') {
      return Math.max(0, Math.round(precioClp - Number(dcto.valor)));
    }
    return precioClp;
  }

  function primerTramoDescuento(campania) {
    const tramos = campania && Array.isArray(campania.tramos) ? campania.tramos : [];
    return (
      tramos.find(function (tramo) {
        return tramo && tramo.tiene_descuento === true;
      }) || null
    );
  }

  function htmlMedioHuincha(campania, precioClp) {
    const tramo = primerTramoDescuento(campania);
    if (!tramo) {
      return '<span class="huincha-club-farmex__unidad">Club Farmex</span>';
    }

    const modo = String((campania && campania.modo_progreso) || '');
    const esUnidad = modo === 'unidad_secuencial' || modo === 'unidad_en_carro';
    const sujeto = esUnidad ? 'Unidad' : 'Compra';
    const sujetoMin = esUnidad ? 'unidad' : 'compra';
    const orden = Number(tramo.orden) || 1;
    const dcto = parseDescuento(tramo);
    const esGratis = dcto.tipo === 'gratis';
    const badgeClass = 'huincha-club-farmex__badge' + (esGratis ? ' huincha-club-farmex__badge--gratis' : '');

    let badgeTop = 'Dscto.';
    let badgeBot = 'Club Farmex';
    if (esGratis) {
      badgeTop = 'GRATIS';
      badgeBot = ordinalPalabra(orden) + ' ' + sujeto;
    } else if (dcto.tipo === 'porcentaje') {
      badgeTop = String(dcto.valor).replace('.', ',') + '%';
      badgeBot = 'Dscto.';
    } else if (dcto.tipo === 'monto') {
      badgeTop = formatClp(dcto.valor);
      badgeBot = 'Dscto.';
    } else if (dcto.tipo === 'despacho_gratis') {
      badgeTop = 'GRATIS';
      badgeBot = 'Despacho';
    }

    const unidadTexto = esGratis
      ? ordinalHuincha(orden) + ' ' + sujetoMin
      : orden + '° ' + sujeto;

    let precioTexto = '';
    if (esGratis) {
      precioTexto = 'Precio Final: $0';
    } else if (dcto.tipo === 'despacho_gratis') {
      precioTexto = 'Precio Final despacho: $0';
    } else if (precioClp > 0 && (dcto.tipo === 'porcentaje' || dcto.tipo === 'monto')) {
      precioTexto = 'Precio Final: ' + formatClp(precioFinal(precioClp, dcto));
    }

    return (
      '<span class="' +
      badgeClass +
      '">' +
      '<span class="huincha-club-farmex__badge-pct">' +
      escapeHtml(badgeTop) +
      '</span>' +
      '<span class="huincha-club-farmex__badge-sub">' +
      escapeHtml(badgeBot) +
      '</span></span>' +
      '<span class="huincha-club-farmex__info">' +
      '<span class="huincha-club-farmex__unidad">' +
      escapeHtml(unidadTexto) +
      '</span>' +
      (precioTexto
        ? '<span class="huincha-club-farmex__precio">' + escapeHtml(precioTexto) + '</span>'
        : '') +
      '</span>'
    );
  }

  function ariaHuincha(campania, precioClp) {
    const tramo = primerTramoDescuento(campania);
    if (!tramo) return 'Club Farmex';
    const dcto = parseDescuento(tramo);
    const orden = Number(tramo.orden) || 1;
    if (dcto.tipo === 'gratis') {
      return 'GRATIS ' + ordinalPalabra(orden) + ' unidad. Precio final $0';
    }
    if (dcto.tipo === 'porcentaje') {
      return dcto.valor + '% dcto. Precio final ' + formatClp(precioFinal(precioClp, dcto));
    }
    return String(tramo.beneficio || 'Club Farmex');
  }

  function pintarHuinchas(huinchas, campanias) {
    const primera = Array.isArray(campanias) && campanias.length > 0 ? campanias[0] : null;
    huinchas.forEach(function (el) {
      const dcto = el.querySelector('.huincha-club-farmex__dcto');
      const btn = el.querySelector('.huincha-club-farmex__btn');
      const precioClp = getPrecioClp(el);
      if (dcto) dcto.innerHTML = htmlMedioHuincha(primera, precioClp);
      if (btn) btn.setAttribute('aria-label', 'Club Farmex: ' + ariaHuincha(primera, precioClp));
      el.hidden = false;
      el.style.display = '';
    });
  }

  function abrirModal() {
    const body = document.getElementById('cffFichaBody');
    const titulo = document.getElementById('cffFichaTitulo');
    if (!body) return;

    if (titulo) {
      titulo.textContent = 'Club Farmex';
    }

    body.innerHTML = renderCampanias(campaniasCache);
    showOverlay();
  }

  function bindClicks(huinchas) {
    huinchas.forEach(function (el) {
      const btn = el.querySelector('.huincha-club-farmex__btn') || el;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        abrirModal();
      });
    });
  }

  function bindCerrar() {
    const closeBtn = document.getElementById('cffFichaClose');
    const okBtn = document.getElementById('cffFichaOk');
    const overlay = getOverlay();

    if (closeBtn) closeBtn.addEventListener('click', hideOverlay);
    if (okBtn) okBtn.addEventListener('click', hideOverlay);
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) hideOverlay();
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && getOverlay() && getOverlay().classList.contains('is-open')) {
        hideOverlay();
      }
    });
  }

  async function init() {
    const huinchas = Array.prototype.slice.call(document.querySelectorAll('.huincha-club-farmex'));
    if (huinchas.length === 0) return;

    const first = huinchas[0];
    const productId = (first.getAttribute('data-product-id') || '').trim();
    const sku = (first.getAttribute('data-sku') || '').trim();
    if (!productId && !sku) return;

    const params = new URLSearchParams();
    if (sku) params.set('sku', sku);
    if (productId) params.set('id_producto', productId);

    const url = getApiBase() + '/api/club-farmex/ficha?' + params.toString();
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: getApiHeaders(),
      });
      if (!response.ok) {
        console.warn('[Club Farmex ficha] API no disponible (' + response.status + '): ' + url);
        return;
      }

      const contentType = (response.headers.get('content-type') || '').toLowerCase();
      if (contentType.indexOf('application/json') === -1) {
        console.warn('[Club Farmex ficha] Respuesta no JSON. URL:', url);
        return;
      }

      const data = await response.json();
      if (!data || data.hay_club_farmex !== true || !Array.isArray(data.campanias) || data.campanias.length === 0) {
        console.info('[Club Farmex ficha] Producto sin campaña activa', {
          sku: sku,
          id_producto: productId,
        });
        return;
      }

      campaniasCache = data.campanias;
      pintarHuinchas(huinchas, campaniasCache);
      bindClicks(huinchas);
      bindCerrar();
    } catch (e) {
      console.warn('[Club Farmex ficha] Error consultando API', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
